import types from "@/data/types"

const rules = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
        case types.OSS_API_INVENTORY:
        case types.OSS_WEB_INVENTORY:
        case types.OSS_CREDITS:
            return {
                separator: ":",
                length: 3,
                items: ["team", "email", "password"]
            }
        case types.TM_INVOICES:
            return {
                separator: ":",
                length: 3,
                items: ["team", "email", "password"]
            }
        case types.BALLPARK_APP:
        case types.BALLPARK_WEB:
            return {
                separator: ":",
                length: 3,
                items: ["team", "email", "password"],
                ignore: ["team"]
            }
        case types.PACIOLAN_SCRAPE:
            return {
                separator: ":",
                length: 3,
                items: ["paciolan_team", "email", "password"]
            }
        case types.TM_AM_SCRAPE:
            return {
                separator: ":",
                length: [3, 4],
                items: ["team", "email", "password"],
                ignore: ["team"],
                passwordMinLength: 1
            }
        case types.SEATGEEK_SCRAPE:
            return {
                separator: ":",
                length: 2,
                items: ["email", "password"]
            }
        case types.SG:
            return {
                separator: ":",
                length: 2,
                items: ["performer", "required"],
            }
        default:
            console.info("No ruleset for this type: ", type)
            return ""
    }
}

export default rules